import styles from './AccordionItem.module.scss';
import className from 'classnames/bind';
import React, { useEffect, useState } from 'react';
import formatUrlPath from '@/helpers/formatUrlPath';
import { useRouter } from 'next/compat/router';

let cx = className.bind(styles);

export function AccordionItem({ children, className, accordionSettings, anchor }) {
	const { id, openIcon, closeIcon, openItem, setOpenItem, anchorsEnabled, expandMultipleItems } = accordionSettings;
	const [isOpen, setIsOpen] = useState(false);
	const classNameArray = className?.split(' ') || [];
	const pathname = useRouter().asPath.split(/[#]/)[0];

	function handleOpen() {
		if (expandMultipleItems) {
			setIsOpen(!isOpen);
			if (anchorsEnabled && !isOpen) {
				const url = `${pathname}${anchor ? `#${formatUrlPath(anchor)}` : ''}`;
				history.replaceState({ ...window.history.state, as: url }, document.title, url);
			}
		} else {
			openItem?.id === `${id}` ? setOpenItem(null) : setOpenItem({ id: `${id}`, anchor: formatUrlPath(anchor) });
		}
	}

	useEffect(() => {
		if (window.location.hash.replace(/^#(.*)$/, '$1') === formatUrlPath(anchor)) {
			if (expandMultipleItems) {
				setIsOpen(true);
			} else if (openItem === undefined) {
				setOpenItem({ id: `${id}`, anchor: formatUrlPath(anchor) });
			}
		}
	}, []);

	return (
		<div id={formatUrlPath(anchor)} className={cx(['ns_accordion-item', 'accordion-item', (isOpen || openItem?.id === `${id}`) && 'open', ...classNameArray])}>
			{React.Children.map(children, (child) => {
				return React.cloneElement(child, {
					accordionSettings: {
						id,
						openItem,
						openIcon,
						closeIcon,
						isOpen,
						handleOpen,
					},
				});
			})}
		</div>
	);
}
